import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';

import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import { signaturePacketTableColumns } from '../../constants';
import { WetSignatureUploadHistoryResponseDto } from '../../types';
import TableBody from './tableBody';
import MobileTable from './tableMobile';

interface TableProps {
  signaturePacketTableData: WetSignatureUploadHistoryResponseDto[];
  sort: ISort;
  loading: boolean;
  refetch: () => void;
  setSort: (value: ISort) => void;
  viewSignaturePacket: (fileName: string) => Promise<void>;
}

const Table = ({ signaturePacketTableData, sort, setSort, refetch, loading, viewSignaturePacket }: TableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>{loading ? <Loader /> : <MobileTable signaturePacketTableData={signaturePacketTableData} viewSignaturePacket={viewSignaturePacket} />}</>
      ) : (
        <>
          <TableHeader refetch={refetch} columns={signaturePacketTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? <Loader /> : <TableBody signaturePacketTableData={signaturePacketTableData} viewSignaturePacket={viewSignaturePacket} />}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default Table;
